import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App/App";
//import "@fortawesome/fontawesome-free/css/all.min.css";

ReactDOM.render(<App/>, document.getElementById("root"));
